import JobAlerts from ".";
import { DashboardSuspense } from "../../dashboard_suspense";
import { Header } from "./header";

const JobAlertsWidget = () => {
  return (
    <div className="job-alerts-widget">
      <DashboardSuspense renderHeader={() => <Header />}>
        <JobAlerts />
      </DashboardSuspense>
    </div>
  );
};

export default JobAlertsWidget;
